import { Void } from "@pdfking/tfunc"
import proxy from "@pdfking/workflow/utils/proxy"
import { defineComponent } from "vue"
import { dismiss_dropdowns } from "../core/bootstrap"
import toggle_class from "../dom/toggle_class"
import navigate from "../routes/navigate"
import keyboard from "../state/keyboard"

export default defineComponent({
  computed: proxy(keyboard, { ESCAPE: "escape_pressed" }),
  methods: {
    close() {
      navigate()
    },
  },
  mounted() {
    const toggled: string | undefined = (this as any).toggled_class
    if (toggled) toggle_class(document.body, { [toggled]: true })
  },
  render: Void,
  unmounted() {
    const toggled: string | undefined = (this as any).toggled_class
    if (toggled) toggle_class(document.body, { [toggled]: false })
  },
  watch: {
    escape_pressed(_v: any) {
      // @ts-expect-error - Expected 1 arguments, but got 0
      dismiss_dropdowns()
      this.close()
    },
  },
})
